module.exports = __webpack_public_path__ + "static/media/stem-sprite-student-portal.1dbf1b62.png";